module.exports = __webpack_public_path__ + "static/features-phone-truaccent-6a49a7a324a5576528de9b79891c9699.png";